import { useMutation } from "@tanstack/react-query";
import type {
  BrandAiExtractRequest,
  GenerateOutlineRequest,
  GeneratePromptRequest,
  GenerateSlideRequest,
  GenerateSlidesLayoutsRequest,
  OutlineItem,
} from "@/pages/how-to-start/types/generation";
import { docpilotApi } from "./docpilot.api";

export const useGenerateOutlineMutation = () => {
  return useMutation({
    mutationFn: (variables: {
      body: GenerateOutlineRequest;
      onPartialSlides?: (slides: OutlineItem[]) => void;
      signal?: AbortSignal;
    }) =>
      docpilotApi.generateOutline(
        variables.body,
        variables.onPartialSlides,
        variables.signal,
      ),
  });
};

export const useGenerateSlidesLayoutsMutation = () => {
  return useMutation({
    mutationFn: (variables: {
      body: GenerateSlidesLayoutsRequest;
      signal?: AbortSignal;
    }) => docpilotApi.generateSlidesLayouts(variables.body, variables.signal),
  });
};

export const useGeneratePromptMutation = () => {
  return useMutation({
    mutationFn: (body: GeneratePromptRequest) =>
      docpilotApi.generatePrompt(body),
  });
};

export const useGenerateSlideMutation = () => {
  return useMutation({
    mutationFn: (variables: {
      body: GenerateSlideRequest;
      signal?: AbortSignal;
    }) => docpilotApi.generateSlide(variables.body, variables.signal),
  });
};

export const useBrandAiExtractMutation = () => {
  return useMutation({
    mutationFn: ({
      body,
      signal,
    }: {
      body: BrandAiExtractRequest;
      signal?: AbortSignal;
    }) => docpilotApi.brandAiExtract(body, signal),
  });
};
